import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Row } from 'react-bootstrap';

import BaselineUpdateContainer from './../Containers/BaselineUpdateContainer.jsx';

const CaseAmendingBaselineUpdateComponent = ({
  visible,
  jobTypes,
  imageName,
  onHide
}) => (
  <Modal show={visible} onHide={onHide} bsSize="lg">
    <Modal.Header closeButton>
      <Modal.Title>Update Case Amending Baseline</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Row>
        <BaselineUpdateContainer imageName={imageName} jobTypes={jobTypes} />
      </Row>
    </Modal.Body>
  </Modal>
);


CaseAmendingBaselineUpdateComponent.propTypes = {
  visible: PropTypes.bool.isRequired,
  jobTypes: PropTypes.array.isRequired,
  imageName: PropTypes.string.isRequired,
  onHide: PropTypes.func.isRequired
};

export default CaseAmendingBaselineUpdateComponent;


// WEBPACK FOOTER //
// src/Components/CaseAmendingBaselineUpdateComponent.jsx